import { ZogoScreen } from '@/screens/index'

export default function () {
  return <ZogoScreen />
}
